export const action = {
  PIPELINES_LOADING: 'PIPELINES_LOADING',
  PIPELINES_LOADED: 'PIPELINES_LOADED',
  PIPELINES_FETCHED: 'PIPELINES_FETCHED',
};
